import {
  ServiceSummaryVariantIconColor,
  ITotalsServiceSummary,
  SERVICE_SUMMARY_VARIANTS
} from 'components/SummaryBanner/SummaryBanner.types';
import TotalsInServiceSummary from '../TotalsInServiceSummary/TotalsInServiceSummary';
import QuoteStatusInServiceSummary from '../QuoteStatusInServiceSummary/QuoteStatusInServiceSummary';
import { BordOneToneIcon } from 'components/NudosComponents';
import './PendingQuote.scss';

interface IPendingQuoteProps {
  quoteLink?: string;
  totals?: ITotalsServiceSummary;
  isManualQuote?: boolean;
}

const PendingQuote = ({ totals = { totalUSD: 0, total: 0, currency: 'USD' }, ...rest }: IPendingQuoteProps) => {
  return (
    <div className="serviceSummaryBanner pendingQuote">
      <TotalsInServiceSummary totals={totals} />
      <QuoteStatusInServiceSummary
        variant="pending"
        icon={
          <BordOneToneIcon
            variant="clock"
            customWidth="10px"
            stroke={ServiceSummaryVariantIconColor[SERVICE_SUMMARY_VARIANTS.PENDING]}
          />
        }
        {...rest}
      />
    </div>
  );
};

export default PendingQuote;
